import abacus from '@homeaway/abacus-client-utils';
import config from '../config';

abacus.initialize(config.abacusEvaluationData || {});

const abacusWrapper = {
    trueExposed: {},
    /**
     * returns abacus experiment object if is not native or, if is native and is in list of native test
     * @param {string} testName
     * @returns {object} abacusBucket
     */
    evaluateExperiment(testName) {
        return abacus.evaluateExperiment(testName);
    },
    /**
     * return test bucket value
     * @param {string} testName
     * @returns {integer} abacusTestValue
     */
    getAbacusBucketValue(testName) {
        return testName ? this.evaluateExperiment(testName).value : 0;
    },
    /**
     * return true if test is active
     * @param {string} testName
     * @returns {boolean} abacusTestEnabled
     */
    isAbacusTestEnabled(testName) {
        return this.getAbacusBucketValue(testName) > 0;
    },
    /**
     * log the test and return test bucket value
     * @param {string} testName
     * @returns {integer} abacusTestValue
     */
    getAbacusBucketValueAndLog(testName) {
        return testName ? this.evaluateExperimentAndLog(testName).value : 0;
    },
    /**
     * log the test and return boolean specifying if the test is active
     * @param {string} testName
     * @returns {boolean} abacusTestEnabled
     */
    isAbacusTestEnabledAndLog(testName) {
        this.evaluateExperimentAndLog(testName);
        return this.isAbacusTestEnabled(testName);
    },
    /**
     * add test to exposed test list
     * @param {string} testName
     */
    addTrueExposed(testName) {
        this.trueExposed[testName] = true;
    },
    /**
     * returns abacus experiment object & logs exposure once if is not native or, if is native and is in list of native test
     * @param {string} testName
     * @returns {object} abacusBucket
     */
    evaluateExperimentAndLog(testName) {
        if (!this.trueExposed[testName]) {
            this.trueExposed[testName] = true;
            return abacus.evaluateExperimentAndLog(testName);
        }
        return abacus.evaluateExperiment(testName);
    },
};

export default abacusWrapper;
